import { config } from '@/pageConfig/policyTwo/de/de';
import { PolicyTwoPageTemplate } from '@/pageTemplate/PolicyTwoPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function RentersPage() {
  const { trackEvent } = useAnalyticsContext();
  useEffect(() => trackEvent('policy-two_page.viewed', { variant: 'default', lang: 'de-DE' }), [trackEvent]);

  return <PolicyTwoPageTemplate config={config} />;
}
